import { FC } from 'react';

import { usePermissions } from '@mint-lib/profile-helpers';

import { StaticCurrencySpan, StaticNumericSpan } from '@myn/mui';

import { CurrencyFieldProps } from '../types.js';
import TextVariant from './TextVariant.jsx';

type Props = Omit<CurrencyFieldProps, 'variant'>;

const CurrencyVariant: FC<Props> = ({
  currency,
  value,
  decimalLimit,
  isEmptyValueHidden = false,
  scale,
  color,
}) => {
  const { getPermissionField } = usePermissions();

  const isNonFinancialUser = !getPermissionField('financialDataFeature');
  const isValidValue = !!value || value === 0;
  const formattingOptions = {
    minDecimals: decimalLimit,
    maxDecimals: decimalLimit,
    min: 0,
  };

  if (isNonFinancialUser) {
    return (
      <TextVariant scale={scale} color={color}>
        ---
      </TextVariant>
    );
  }

  if (isEmptyValueHidden || !isValidValue) {
    return null;
  }

  if (!currency) {
    return <StaticNumericSpan number={value} options={formattingOptions} />;
  }

  return (
    <StaticCurrencySpan
      number={value}
      currency={currency}
      options={formattingOptions}
    />
  );
};

export default CurrencyVariant;
